import {createFileRoute} from '@tanstack/react-router'

import GlossaryScreen from '@protected/glossary'

export const Route = createFileRoute('/_protected/glossary')({component: GlossaryScreen})
